import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { JanelaAtualizacaoInformacoes } from './janelas-atualizacao-informacoes.model';

export class AcompanhamentoProcessualOperacao extends BaseEntity {

	public cnpjAgenteFinanceiro: string;
	
	public idOperacaoAgente: string;
	
	public sistemaCobranca: string;
	
	public contratoCobranca: number | string;

    public dataEnvio: Date;
    
    public cobrancaEncerrada: string;

	public observacoes: string;
	
	public numeroProcesso: string;
	
	public juizo: string;
	
	public comarca: string;
	
	public especieAcaoRecurso: string;
	
	public faseProcessual: string;
    
	public idOperacao: number;
    
	public tipoCobranca: string;
    
	public statusProtocolo: string;

	public valorSaldoDevedorTotal: number;
	
	public valorSaldoDevedorDePrincipal: number;

	public valorSaldoDeJurosNaNormalidade: number;

	public valorSaldoDeEncargosMoratorios: number;

}

export class EntradaAcompanhamentoProcessualOperacaoDTO extends BaseEntity {

	public idOperacaoAgenteCreditoLivre: string;
	
	public sistemaRepasse: string;
	
	public contratoRepasse: number | string;

    public cobrancaEncerrada: string;

	public observacoes: string;
	
	public numeroProcesso: string;
	
	public juizo: string;
	
	public comarca: string;
	
	public especieAcaoRecurso: string;
	
	public faseProcessual: string;
    
	public tipoCobranca: string;

	public valorSaldoDevedorTotal: number;
	
	public valorSaldoDevedorDePrincipal: number;

	public valorSaldoDeJurosNaNormalidade: number;

	public valorSaldoDeEncargosMoratorios: number;

}

export class JanelaAcompanhamentoProcessual extends JanelaAtualizacaoInformacoes {
}

export class SaidaAcompanhamentoProcessualOperacaoDTO {
	public idOperacaoAgenteCreditoLivre: string;

	public sistemaRepasse: string;
	
	public contratoRepasse: string;
}

export class SaidaLoteAcompanhamentoProcessualOperacaoDTO {
	public operacoes: SaidaAcompanhamentoProcessualOperacaoDTO[];
}

export class EntradaLoteAcompanhamentoProcessualOperacaoDTO {
	public operacoes: EntradaAcompanhamentoProcessualOperacaoDTO[];
}

export class FaseProcessual {
	public codigo: string;
	public descricao: string;
}

export class EspecieAcaoRecurso {
	public codigo: string;
	public descricao: string;
}

export const TIPOS_COBRANCA = [
	{
		codigo: 'J',
		label: 'Judicial'
	},

	{
		codigo: 'E',
		label: 'Extrajudicial'
	}
];